<template>
  <main v-bind="dKey('pageid', pageName, pageId)">
    <HomeSlider v-bind:title="info.b1title"
                v-bind:subtitle="info.b1subtitle"
                v-bind:down-title="info.b1subtitleUnder">
    </HomeSlider>

    <HomeAbout v-bind:title="info.b2title"
               v-bind:subtitle="info.b2subtitle"
               v-bind:bg-title="info.b2imageTitle"
               v-bind:content="info.b2text">
    </HomeAbout>

    <WhatWeDo v-bind:title="info.b3title"
              v-bind:subtitle="info.b3subtitle"
              v-bind:bg-title="info.b3titleRight"
              v-bind:services="info.b3array">
    </WhatWeDo>

    <TypeWeight v-bind:title="info.b4title"
                v-bind:subtitle="info.b4subtitle"
                v-bind:bg-title="info.b4titleRight"
                v-bind:articles="info.b4array">
    </TypeWeight>

    <LogisticServices v-bind:title="info.b5title"
                      v-bind:subtitle="info.b5subtitle"
                      v-bind:bg-title="info.b5titleRight"
                      v-bind:services="info.b5array">
    </LogisticServices>

    <OurExcellence v-bind:title="info.b6title"
                   v-bind:subtitle="info.b6subtitle"
                   v-bind:bg-title="info.b6titleRight"
                   v-bind:advantages="info.b6array">
    </OurExcellence>

    <Vacancies v-bind:title="info.b7title"
               v-bind:subtitle="info.b7subtitle"
               v-bind:bg-title="info.b7vacantionDown"
               v-bind:content="info.b7text"
               v-bind:link="info.b7link"
               v-bind:link-text="info.b7linkName"
               v-bind:top-women="info.b7topWomen"
               v-bind:women-name="info.b7womenName"
               v-bind:who-woman="info.b7whoWoman">
    </Vacancies>

    <News v-bind:title="info.b8title"
          v-bind:subtitle="info.b8subtitle"
          v-bind:bg-title="info.b8titleRight">
    </News>

    <Map v-bind:title="info.b9title"
         v-bind:subtitle="info.b9subtitle"
         v-bind:bg-title="info.b9titleDown"
         v-bind:submit="info.b9submit"
         v-bind:country="info.b9country"
         v-bind:city="info.b9city">
    </Map>

  </main>
</template>

<script>

import {HTTP} from '../http-common';

import HomeAbout from './HomePage/HomeAbout.vue'
import HomeSlider from './HomePage/HomeSlider.vue'
import WhatWeDo from './HomePage/WhatWeDo.vue'
import TypeWeight from './HomePage/TypeWeight.vue'
import LogisticServices from './HomePage/LogisticServices.vue'
import OurExcellence from './HomePage/OurExcellence.vue'
import Vacancies from './HomePage/Vacancies.vue'
import News from './HomePage/News.vue'
import Map from './Map.vue'

export default {
  name: 'Home',

  data() {
    return {
      info: {},
      pageId: 0,
      pageName: 'home',
      meta_title: '',
      meta_description: '',
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.$root.getPage('home', this.$root.language_id, response => {
      this.info = response.info
      this.pageId = response.pageId
      this.meta_title = response.meta_title
      this.meta_description = response.meta_description
    })
  },

  watch:{
    $route (to, from) {
      this.$root.getPage('home', this.$root.language_id, response => {
        this.info = response.info
        this.pageId = response.pageId
        this.meta_title = response.meta_title
        this.meta_description = response.meta_description
      })
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getData(key, field) {
      if (this.$root.hfInfo[key] && this.$root.hfInfo[key][field])
        return this.$root.hfInfo[key][field]
      return ''
    }
  },

  components: {
    HomeAbout,
    HomeSlider,
    WhatWeDo,
    TypeWeight,
    LogisticServices,
    OurExcellence,
    Vacancies,
    News,
    Map
  }
}

</script>
